<template>
  <div>
    <header-page :style="isCiudadano? 'display: none': ''" showCiudadSelector :disabled="true" />
    <div class="container">
      <breadcrumbs :visible="!isCiudadano"/>
      <div class="row">
        <q-icon class="iconBack col-1" v-if="isCiudadano" name="arrow_back_ios" @click="goBack()" />
        <div v-if="isCiudadano && this.ciudadSelected!=null" class="tituloCiudad col-10">
          {{this.ciudadSelected.name}}
        </div>
      </div>
      <div class="row">
        <div :class="{ 'col-md-12': loopRuning === null, 'col-md-11': loopRuning != null }">
          <q-btn
            v-if="!isCiudadano"
            id="btnPrintPdf"
            @click="printPdf()"
            class="bPrincipal">Imprimir</q-btn>
        </div>
        <div class ='col-sm-1 dBtnLoop' v-if="!isCiudadano && loopRuning != null">
            <q-btn
              flat
              color="primary"
              icon="play_arrow"
              v-if="!this.loopRuning"
              @click="iniciarLoop"
            >
              <q-tooltip>Iniciar Loop</q-tooltip>
            </q-btn>
            <q-btn
              flat
              v-else
              color="primary"
              icon="pause"
              @click="pausarLoop"
            >
              <q-tooltip>Pausar loop</q-tooltip>
            </q-btn>
          </div>
      </div>

      <!--headerIndicador-->
      <HeaderIndicador :dataIndicador="dataIndicador"/>

      <!--respuesta-->
      <Respuesta v-if="this.$route.params.tipo ==='Cualitativo' && Object.keys(this.dataIndicador).length !== 0" :dataIndicador="dataIndicador"/>

      <!--filtro periodo-->
      <PeriodoIndicador v-if="this.$route.params.tipo ==='Cuantitativo' && Object.keys(this.dataIndicadorPeriod).length !== 0" :dataIndicador="dataIndicadorPeriod"/>

      <!--gráficos-->
      <GraficosIndicadorAUE v-if="this.$route.params.tipo ==='Cuantitativo' && Object.keys(this.dataIndicador).length !== 0" :dataIndicador="dataIndicador"/>

      <!--datos intermedios-->
      <DatosIntermedios v-if=" this.$route.params.tipo ==='Cuantitativo' && Object.keys(this.dataIndicador).length !== 0" :dataIndicador="dataIndicador" :idCiudadIndicadorAUE="this.$route.params.idCiudadIndicadorAUE"/>

      <!--Listado instrumentp plan-->
      <q-card v-if=" this.$route.params.tipo ==='Cualitativo' && Object.keys(this.dataIndicador).length !== 0 && dataIndicador.planes.length > 0" class="marginTag">
        <q-card-section>
          <div class="titleCard">Instrumentos/planes existentes</div>
          <ListadoInstrumentoPlan :planes="dataIndicador.planes" :visibleColumns="['nombre', 'fase', 'periodoVigencia']"/>
        </q-card-section>
      </q-card>

      <!--Acciones-->
      <ListadoAcciones :acciones="dataIndicador.acciones" :styleCard="'margin: 20px 0px 0px 0px;'" :visibleColumns="this.isCiudadano ? ['name', 'fase', 'fechaInicio', 'fechaFin'] : ['name', 'fase', 'fechaInicio', 'fechaFin', 'ver']" />

      <!--descripción del indicador-->
      <DescriptionIndicador v-if=" this.$route.params.tipo ==='Cuantitativo'" :dataIndicador="dataIndicador"/>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import DescriptionIndicador from '../components/DescriptionIndicador.vue';
import Respuesta from '../components/Respuesta.vue';
import HeaderIndicador from '../components/HeaderIndicador.vue';
import PeriodoIndicador from '../components/PeriodoIndicador.vue';
import GraficosIndicadorAUE from '../components/GraficosIndicadorAUE.vue';
import { mapGetters } from 'vuex';
import ListadoAcciones from '@/components/Aue/components/ListadoAcciones.vue';
import DatosIntermedios from '../components/DatosIntermedios.vue';
import HeaderPage from '@/components/shared/HeaderPage.vue';
import ListadoInstrumentoPlan from '@/components/PlanAccion/components/ListadoInstrumentoPlan.vue';
import * as detailLoopHelper from '@/components/shared/helpers/detailLoopHelper.js';

export default {
  components: {
    Breadcrumbs,
    DescriptionIndicador,
    HeaderIndicador,
    PeriodoIndicador,
    GraficosIndicadorAUE,
    ListadoAcciones,
    HeaderPage,
    DatosIntermedios,
    Respuesta,
    ListadoInstrumentoPlan
  },
  mixins: [Loading],
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      isCiudadano: 'NGUD/isCiudadano',
      loopIndicatorsInfo: types.LOOP_INDICATORS
    })
  },
  data () {
    return {
      idIndicador: null,
      dataIndicador: {},
      dataIndicadorPeriod: {},
      loopRuning: null
    };
  },
  async mounted () {
    this.$eventHub.$on('updateIndicadorAUE', (idRelacion) => {
      this.getData(false, idRelacion);
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('updateIndicadorAUE');
  },
  destroyed () {
    if (this.timeOutId) {
      clearTimeout(this.timeOutId);
    }
  },
  watch: {
    ciudadSelected () {
      this.getData(false);
    },
    '$route.params.idCiudadIndicadorAUE': {
      handler: function () {
        this.getData(true);
        if (this.loopIndicatorsInfo.indicadores) {
          this.loopRuning = true;
          const boundHelper = detailLoopHelper.initLoop.bind(this);
          this.timeOutId = boundHelper(this.$route.params.idCiudadIndicadorAUE, this.loopIndicatorsInfo.indicadores, this.loopIndicatorsInfo.loopTime);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    goBack () {
      this.$router.back();
    },
    iniciarLoop () {
      if (this.loopIndicatorsInfo.indicadores) {
        this.loopRuning = true;
        const boundHelper = detailLoopHelper.initLoop.bind(this);
        this.timeOutId = boundHelper(this.$route.params.idCiudadIndicadorAUE, this.loopIndicatorsInfo.indicadores, this.loopIndicatorsInfo.loopTime);
      }
    },
    pausarLoop () {
      if (this.timeOutId) {
        clearTimeout(this.timeOutId);
        this.loopRuning = false;
      }
    },
    async getData (paramsChange = false, idRelacion) {
      this.dataIndicador = {};
      this.showLoading();
      const id = idRelacion || this.$route.params.idCiudadIndicadorAUE;
      if (this.ciudadSelected !== null) {
        await this.$store.dispatch(types.ACTION_GET_DETALLE_INDICADOR_AUE, {
          idCiudad: this.ciudadSelected.id,
          idCiudadIndicadorAUE: id
        }).then(response => {
          this.dataIndicador = response;
          this.dataIndicadorPeriod = response;
          this.hideLoading();
        }).catch(() => {
          this.hideLoading();
        });
      }
    },
    printPdf () {
      window.print();
    }
  }
};
</script>

<style lang="scss" scoped>
.marginTag.q-card {
  margin-top: 25px;
  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  .titleCard {
    margin: 0 0px 20px 4px;
    font-size: 20px;
    font-family: DINPro;
    font-weight: bold;
    letter-spacing: 0.29px;
    color: #474848;
  }
}
.bPrincipal{
  float: right;
  margin-bottom: 15px;
}
::v-deep{
  .layout-container.show-layout.unset-all {
    all: inherit !important;
  }
}
.dBtnLoop{
    align-self: start;
    display: flex;
    justify-content: end;
}
.iconBack {
  color:#666;
  font-size: 15px;
  cursor: pointer;
  padding-top: 15px;
  padding-bottom: 15px;
  justify-content: flex-start;
  display: flex;
}
.tituloCiudad {
  font-family: DINPro;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #002f6c;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 640px) {
  ::v-deep {
    .container {
      padding-left: 10px;
      padding-right: 10px;
    }
    .divNameIndic, .titleCard, .titleDetalle{
      font-size: 15px !important;
    }
    .titleDescription{
      font-size: 13px !important;
    }
    .contentDescription{
      font-size: 12px !important;
    }
    .measuring-container {
      margin-top: 15px;
    }
    .measuring, #measuring-big, #measuring-unit-big, .titleDesglose {
      font-size: 14px !important;
    }
    #measuring-date-big, #measuring-date {
      font-size: 10px !important;
    }
    //grafico responsive
    .chart {
      height: 230px !important;
    }
    .grafico.col-12 {
      margin: 0px;
    }
    .divHeader, .divBody, .divLabel{
        font-size: 13px !important;
    }
    .q-table {
        th{
          font-size: 13px !important;
        }
        tbody td{
          font-size: 13px !important;
        }
    }
    .iconDetalle{
      font-size: 24px;
    }
    .q-table {
          th{
            font-size: 13px !important;
          }
          tbody td{
            font-size: 13px !important;
          }
      }
      .q-icon{
        font-size: 24px;
      }
      .titleDetalle {
        font-size: 15px !important;
      }
  }
}
@media print {
  #btnPrintPdf{
      display: none;
  }
}
</style>
